export default (betKey) => {
  const splitKey = betKey.split(':')
  switch (true) {
    case splitKey[1] === 'PAIR':
    case splitKey[1] === 'TRIPLE':
      return splitKey[0] === 'ANY' ? 'all_match_all_select' : splitKey[0]

    case splitKey[2] === 'RED':
      return Array.from({ length: splitKey[0] }, () => 'dice-RED')

    case splitKey[2] === 'GREEN':
      return Array.from({ length: splitKey[0] }, () => 'dice-GREEN')

    case splitKey[2] === 'BLUE':
      return Array.from({ length: splitKey[0] }, () => 'dice-BLUE')

    case betKey === 'ANY:COLOR':
      return ['dice-RED', 'dice-GREEN', 'dice-BLUE']

    default:
      return splitKey[2]
  }
}
